import type { PluginOption } from 'vite';
import { createHash } from 'node:crypto';
import { extname } from 'node:path';

function getHash(text: string) {
  return createHash('sha256').update(text).digest('hex').substring(0, 8);
}

export function hashHtmlFiles(): PluginOption {
  return {
    name: 'hash-html-files',
    enforce: 'post',
    generateBundle(_, bundle) {
      for (const id of Object.keys(bundle)) {
        const outputAsset = bundle[id];
        if (
          outputAsset?.type === 'asset' &&
          extname(outputAsset.fileName) === '.html'
        ) {
          const newFileName = outputAsset.fileName.replace(
            /(\.html)$/,
            `.ch.${getHash(outputAsset.source.toString())}.html`
          );
          outputAsset.fileName = newFileName;
        }
      }
    },
  };
}
